import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { SessionStorageVariables } from '@/enums/SessionStorageVariables';

export const useNavigationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const currentPath = location.pathname;
    const storedPath = sessionStorage.getItem(SessionStorageVariables.CurrentPath);

    if (storedPath && storedPath !== currentPath) {
      sessionStorage.setItem(SessionStorageVariables.PreviousPath, storedPath);
    }

    sessionStorage.setItem(SessionStorageVariables.CurrentPath, currentPath);
  }, [location.pathname]);
};
